<template>
  <div>
  <expired-purchaser-token v-if="expired"></expired-purchaser-token>
  <div v-if="uri_enc.length > 2 && !expired">
    <div v-html='decodeURI(uri_enc)'></div>
  </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import ExpiredPurchaserToken from './ExpiredPurchaserToken';

export default {


  name: 'Campaign',
    components:{
      ExpiredPurchaserToken,
    },
    data() {
      return {
          expired:false,
          rawTemplate: null,
          uri_enc: "",
          firstName:null,
          lastName:null,
          wealthSaverAmt:0,
          urlToken:"",
          consentPath:"",
          emailAddress:"",
      }
    },
  props: {
    msg: String

  },
    computed:{
        environmentVariable:{
            get(){
                if(this.$route.query.env){
                    console.log("env variable=="+ this.$route.query.env)
                    return this.$route.query.env;
                }
                return "";
            }
        },
        baseApiURL:{
            get(){
                if(this.environmentVariable == "dev"){
                    // console.log("baseApiURL ==")
                    // console.log(process.env.VUE_APP_API_BASE_DEV)
                    return process.env.VUE_APP_API_BASE_DEV
                }
                if(this.environmentVariable == "staging"){
                    return process.env.VUE_APP_API_BASE_STAGING
                }
                if(this.environmentVariable == "prod"){
                    return process.env.VUE_APP_API_BASE_PROD
                }
                if(this.environmentVariable == "test"){
                    return process.env.VUE_APP_API_BASE_TEST
                }
                else {
                    return "";
                }
            }
        },
    },
    methods:{
      getTemplate(purchaserToken){
          console.log("getTemplate ==" + this.baseApiURL)
          if(this.baseApiURL){
              axios.get("/campaign/templateData?client="+ purchaserToken,{
                  baseURL: this.baseApiURL,
                  params: {},
                  headers:{
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type, Authorization, Content-Length, X-Requested-With,Oci-User',
                      'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS'
                  }
              })
                  .then(r => r.data)
                  .then(data => {
                      // console.log(data)
                      this.firstName = data.firstName;
                      this.lastName = data.lastName;

                      var wealthSaverObj = JSON.parse(data.artifact);
                      this.wealthSaverAmt = wealthSaverObj.wealthSaverAmt
                      this.emailAddress = wealthSaverObj.emailAddress;
                      this.consentPath = wealthSaverObj.consentPath;

                      this.rawTemplate = data.template.replace("{{name}}", this.firstName+ " " + this.lastName);
                      this.rawTemplate = this.rawTemplate.replace("{{wealthSaverAmt}}", this.wealthSaverAmt);
                      this.rawTemplate = this.rawTemplate.replace("{{consentPath}}", this.consentPath);

                      /*// removing open in browser  link*/
                      this.rawTemplate = this.rawTemplate.replace("If you can't read this email, please", "");
                      this.rawTemplate = this.rawTemplate.replace("view it online", "");

                      /*// removing unsubcribe link*/
                      this.rawTemplate = this.rawTemplate.replace("<span style=\"FONT-SIZE: 8px; LINE-HEIGHT: 12px\">Click</span>", "");
                      this.rawTemplate = this.rawTemplate.replace("<a title=\"\" style=\"TEXT-DECORATION: underline; COLOR: #c28607\" href=\"{{unsubscribePath}}\" target=\"_blank\"><span style=\"FONT-SIZE: 8px; COLOR: #feffff; LINE-HEIGHT: 12px\">unsubscribe</span></a>", "");
                      this.rawTemplate = this.rawTemplate.replace("<span style=\"FONT-SIZE: 8px; LINE-HEIGHT: 12px\">to be removed from further OneClose Inc. offers</span>", "");

                      this.uri_enc = encodeURI(this.rawTemplate);
                  })
                  .catch(error => {
                    if(error.response.status == 403){
                      this.expired = true;
                      console.log("this.expired")
                      console.log(this.expired);
                    }
                      console.log(error);
                  });

          }

        }
    },
  watch:{
    baseApiURL: {
      handler: function (val) {this.getTemplate(this.$route.query.client);},
    }
  },
    created(){
        this.getTemplate(this.$route.query.client);
         },
}
</script>

<style scoped>


  </style>

